import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }

export function render(_ctx, _cache) {
  const _component_router_view = _resolveComponent("router-view")
  const _component_NotificationSnackbar = _resolveComponent("NotificationSnackbar")
  const _component_v_main = _resolveComponent("v-main")
  const _component_v_app = _resolveComponent("v-app")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_app, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_main, null, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.layout), null, {
              default: _withCtx(() => [
                _createVNode(_component_router_view)
              ]),
              _: 1
            })),
            _createVNode(_component_NotificationSnackbar)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}